import { createContext, useContext } from "react";

import type { AppMode } from "@/shared/config";

export interface ModeApi {
  mode: AppMode;
  isDemo: boolean;
  setMode: (mode: AppMode) => void;
}

/**
 * Режим живёт в `shared`, а не в `app`, по правилам слоёв: его читают и
 * страницы, и виджеты, и хуки сущностей, а импортировать «вверх» нельзя. Тот
 * же приём, что у `toast-context.ts`.
 *
 * Контекст отделён от провайдера отдельным модулем: файл, экспортирующий и
 * компоненты, и не-компоненты, ломает Fast Refresh.
 */
export const ModeContext = createContext<ModeApi | null>(null);

export function useMode(): ModeApi {
  const value = useContext(ModeContext);
  if (value === null) {
    // Не молчаливый фолбэк на «реальный»: провайдер обязателен, а тихая
    // подмена означала бы экран, который показывает реальные данные под
    // плашкой DEMO.
    throw new Error("useMode вызван вне ModeProvider");
  }
  return value;
}
